export default __webpack_public_path__ + "static/media/google-compute-engine.0f52e6d6.svg";